/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
<template>
  <div class="mt-1">
    <b-card>
      <b-card-body>
        <!-- detalles generales del curso sobre el alumno -->
        <div class="d-flex flex-sm-row flex-column justify-content-between align-items-start mb-1">
          <!-- 1st Col -->
          <div class="mb-1 mb-sm-0">
            <span class="text-muted mb-50 d-block">Modalidad </span>
            <span><b> {{ nombreModalidad(materia.modalidad) }} </b></span>
          </div>
          <!-- 2nd Col -->
          <div class="mb-1 mb-sm-0">
            <span class="text-muted mb-50 d-block">Parciales</span>
            <span><b> {{ (materia.parciales) ? materia.parciales : 'N/A' }} </b></span>
          </div>
          <div class="mb-1 mb-sm-0">
            <span class="text-muted mb-50 d-block">Status</span>
            <span :class="(materia.status=='NA') ? 'text-danger' : 'text-dark'"><b> {{ materia.fstatus }} </b></span>
          </div>
          <div class="mb-1 mb-sm-0">
            <span class="text-muted mb-50 d-block">Compañeros</span>
            <span><b-link
              :to="`/alumno/classmate/${materia.curso_id}`"
              target="_blank"
            >
              <b-badge
                pill
                class="float-right"
                variant="light-completo"
              >
                <feather-icon
                  icon="UsersIcon"
                  class="mr-1"
                />
                <span class="">Mostrar</span>
              </b-badge> </b-link></span>
          </div>
          <div>
            <span class="text-muted mb-50 d-block text-center">Cal. Final.</span>
            <span><b :class="(materia.cal_fin > 0) ? 'text-mood' : 'text-warning'"> {{ (materia.cal_fin > 0) ? materia.cal_fin : 'N/A' }} </b></span>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <!-- tabs de contenido el curso -->
    <b-tabs
      content-class="mt-1 mb-4"
      justified
    >
      <!-- calificaciones y opciones sobre ellas -->
      <b-tab
        active
        title="Evaluaciones por parcial"
      >
        <p>Evaluaciones en base a los cursos y actividades del salon de clases (moodle).</p>
        <!-- mensaje en caso de no tener evaluaciones capturadas -->
        <b-alert
          v-show="calificaciones.length <= 0"
          variant="warning"
          show
        >
          <h4 class="alert-heading">
            <feather-icon
              class="mr-25"
              icon="AlertCircleIcon"
            /><span class="ml-25">Hola, por el momento no se ha emitido ninguna evaluación.</span>
          </h4>
        </b-alert>
        <!-- list parciales -->
        <b-table
          v-show="calificaciones.length > 0"
          responsive
          :items="calificaciones"
          :fields="fields"
          class="mb-0"
        >
          <template #cell(numParcial)="data">
            <span class="text-nowrap">
              # {{ data.value }}
            </span>
          </template>

          <template #cell(concepto)="data">
            <small class="text-muted"><b-badge
              class="float-center"
              :variant="(data.item.calif_status_id == 5) ? 'light-warning' : 'light-secondary'"
            >
              <span>{{ data.item.concepto }}</span>
            </b-badge></small>
          </template>

          <!-- Column: id : solicitar cambios -->
          <template #cell(id)="data">
            <div class="text-nowrap text-center">
              <b-link
                v-show="data.item.calif_status_id == 4"
                class="font-weight-bold text-secondary"
                @click="requestCambio(data.item)"
              >
                <feather-icon
                  :id="`curso-row-${data.item.id}-edit-icon`"
                  icon="PhoneCallIcon"
                  class="cursor-pointer"
                  size="18"
                  :class="data.item.activo ? 'mx-1' : 'mr-1'"
                />
              </b-link>
              <b-tooltip
                title="Solicitar Aclaración"
                placement="right"
                :target="`curso-row-${data.item.id}-edit-icon`"
              />
              <b-badge
                v-show="data.item.calif_status_id != 4"
                variant="light-primary"
              >
                No disponibles
              </b-badge>
            </div>
          </template>
        </b-table>

      </b-tab>
      <!-- modulos sobre ese curso -->
      <b-tab
        title="Modulos de materia"
      >
        <b-alert
          v-show="modulos.length <= 0"
          variant="dark"
          class="mt-2"
          show
        >
          <h4 class="alert-heading">
            <feather-icon
              class="mr-25"
              icon="HelpCircleIcon"
            /><span class="ml-25">Hola, por el momento no se ha registrado ningun modulo.</span>
          </h4>
        </b-alert>
        <!-- modulos -->
        <b-media
          v-for="mod in modulos"
          :key="mod.id"
          class="mt-2"
          no-body
        >
          <b-media-aside>
            <b-avatar
              variant="primary"
            > <feather-icon icon="BookmarkIcon" /> </b-avatar>
          </b-media-aside>
          <b-media-body>
            <h6 class="font-weight-bolder">
              # {{ mod.orden }} | {{ mod.titulo }}
            </h6>
            <b-card-text>
              <!-- eslint-disable vue/no-v-html -->
              <div v-html="mod.descripcion" />
              <!-- eslint-enable -->
            </b-card-text>
          </b-media-body>
        </b-media>
        <!-- eslint-enable -->
        <hr class="my-2">
      </b-tab>
      <!-- seriaciones necesarias sobre ese curso -->
      <b-tab title="Seriación">
        <b-alert
          v-show="seriaciones.length <= 0"
          variant="dark"
          class="mt-2"
          show
        >
          <h4 class="alert-heading">
            <feather-icon
              class="mr-25"
              icon="InfoIcon"
            /><span class="ml-25">Hola, este curso no requiere ninguna seriación.</span>
          </h4>
        </b-alert>
        <b-media
          v-for="mod in seriaciones"
          :key="mod.id"
          no-body
        >
          <b-media-aside>
            <b-avatar
              variant="primary"
            > <feather-icon icon="LockIcon" /> </b-avatar>
          </b-media-aside>
          <b-media-body>
            <h6 class="font-weight-bolder">
              {{ mod.nombre }}
            </h6>
            <b-card-text>
              {{ seriacionTipo(mod.tipo) }}
            </b-card-text>
          </b-media-body>
        </b-media>
      </b-tab>
    </b-tabs>
    <!-- solicitar aclaracion de calificacion -->
    <b-modal
      id="mod-solicitud"
      v-model="shw_solicitud"
      size="lg"
      title="Solicitud de aclaración"
      hide-footer
      no-body
      @hide="shw_solicitud = false"
    >
      <!-- detalle persona -->
      <b-col
        lg="12"
        md="12"
      >
        <mod-solicitud
          class="mb-2"
          :calif="select_calf"
          :periodoxmateria="inperiodo"
        />
      </b-col>
    </b-modal>
  </div>
</template>
<script>

import {
  BCol,
  BBadge,
  BTabs,
  BTab,
  BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BAvatar,
  BAlert,
  BTable,
  BLink,
  BTooltip,
  BCard,
  BCardBody,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-unresolved
// eslint-disable-next-line import/extensions
import { seriacionTipo, nombreModalidad } from '@core/utils/filter'
import ModSolicitud from './components/mod-solicitud.vue'

export default {
  components: {
    BCol,
    BBadge,
    BCardText,
    BTabs,
    BTab,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BAlert,
    BTable,
    BLink,
    BTooltip,
    ModSolicitud,
    BCard,
    BCardBody,
  },
  props: {
    materia: {
      type: Object,
      default: () => {},
      require: true,
    },
    info: {
      type: Object,
      default: () => {},
      required: true,
    },
    calificaciones: {
      type: Array,
      default: () => [],
      required: true,
    },
    modulos: {
      type: Array,
      default: () => [],
      required: true,
    },
    seriaciones: {
      type: Array,
      default: () => [],
      required: true,
    },
    inperiodo: {
      type: Number,
      default: () => 0,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'numParcial', label: 'Parcial',
        },
        'faltas',
        {
          key: 'calif', label: 'Evaluación',
        },
        {
          key: 'observacion_profesor', label: 'Observaciones',
        },
        {
          key: 'concepto', label: 'Status',
        },
        {
          key: 'id', label: 'acciones',
        },
      ],
      parciales: [],
      select_calf: {},
      load_par: false,
      shw_solicitud: false,
      seriacionTipo,
      nombreModalidad,
    }
  },
  created() {

  },
  methods: {
    getparciales(objMat) {
      if (this.parciales.length <= 0) {
        this.load_par = true
        const delayInMilliseconds = 1000 // 1 second
        this.parciales = []
        setTimeout(() => {
          this.parciales = objMat.parciales
          this.load_par = false
        }, delayInMilliseconds)
      }
    },
    requestCambio(item) {
      this.select_calf = item
      this.shw_solicitud = true
    },
  },
}
</script>

<style>
 .text-mood {
   color: #11b394;
 }
</style>
